import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Input } from '../../Input/Input.es.js';
import { MoneyInputInner } from '../MoneyInput.Inner/MoneyInput.Inner.es.js';

const MoneyInputCore = /*#__PURE__*/ forwardRef(({ label, display, labelProps, labelSuffix, name, error, warning, message, className, emphasize, value, loading, padded, locale = 'en-US', currencyConfig, disableCurrencySymbol = false, disableCurrencyVariant = false, onChange, onBlur, onKeyUp, onKeyDown, disabled, placeholder, readOnly, ...rest }, ref)=>{
    return jsx(Input, {
        className: className,
        disabled: disabled,
        display: display,
        emphasize: emphasize,
        error: error,
        label: label,
        labelProps: labelProps,
        labelSuffix: labelSuffix,
        loading: loading,
        message: message,
        placeholder: placeholder,
        readOnly: readOnly,
        value: value == null ? value : String(value),
        warning: warning,
        children: jsx(MoneyInputInner, {
            ref: ref,
            currencyConfig: currencyConfig,
            disableCurrencySymbol: disableCurrencySymbol,
            disableCurrencyVariant: disableCurrencyVariant,
            locale: locale,
            name: name,
            onBlur: onBlur,
            onChange: onChange,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            padded: padded,
            ...rest
        })
    });
});
MoneyInputCore.displayName = 'MoneyInput.Core';

export { MoneyInputCore, MoneyInputCore as default };
//# sourceMappingURL=MoneyInput.Core.es.js.map
